export default __webpack_public_path__ + "static/heading_artists-aa945196105ebb27de27ab3723a247a0.svg";